import React from 'react'
import styled from 'styled-components'

import Message from '../components/message'
import bg from '../images/index/hawkins-home.jpg'
import theme from '../utils/theme'

const Home = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;

  @media (min-width: ${theme.app.mobileBreakpoint}) {
    border: 10px solid ${theme.colors.bg};
  }
`

const Content = styled.div`
  padding: 1.5rem;
  text-align: center;
  max-width: 48rem;
  color: white;
`

const Heading = styled.h1`
  font-size: 2.5rem;
`

const Lead = styled.p`
  font-size: 1.5rem;
`

const IndexPage = ({data}) => (
  <Home>
    <Content>
      <Heading>
        Creative Landscape Design, Construction &amp; Maintenance
      </Heading>
      <Lead>
        {data.site.siteMetadata.title}, led by Landscape Designer Bob Hawkins, is the DC area's premier landscape design, build and service company.
      </Lead>
      <Message>
        Call to schedule a free estimate {data.site.siteMetadata.phone}
      </Message>
    </Content>
  </Home>
)

export default IndexPage;

export const query = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
        phone
      }
    }
  }
`


// WEBPACK FOOTER //
// ./src/pages/index.js